/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FinancialEditFinancialResponse } from "./FinancialEditFinancialResponse";

export type FinancialEditFinancialResponseApiRespoonse = {
  data?: FinancialEditFinancialResponse;
  status?: FinancialEditFinancialResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FinancialEditFinancialResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
